import React, { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Checkbox
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";

const SpaceNoticeboardAdd = ({ open, onClose, community, creators = [], communityName = "", onSuccess = () => { } }) => {

    const [formData, setFormData] = useState({
        community: community,
        title: "",
        description: "",
        mediaUrl: null, // image to upload
        creator: "", // dropdown
        redirectUrl: "", // https URL
        redirectType: "inside", // outside/inside
        redirectId: "", // event ID if any
        idType: "", // type (Event or empty)
        position: "",
        endTime: ""
    });

    useEffect(() => {
        setFormData(prev => ({ ...prev, community: community }))
    }, [open])

    const [notifyUsers, setNotifyUsers] = useState(false)


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, mediaUrl: e.target.files[0] }));
    };

    const isValidNumber = (value) => {
        return !isNaN(value) && !isNaN(parseFloat(value));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isValidNumber(formData.position)) {
            const data = new FormData();
            data.append("space", formData.community);
            data.append("title", formData.title);
            data.append("description", formData.description);
            data.append("creator", formData.creator);
            data.append("redirectUrl", formData.redirectUrl);
            data.append("redirectType", formData.redirectType === "none" ? "outside" : formData.redirectType);
            data.append("redirectId", formData.redirectId);
            data.append("idType", formData.idType);
            data.append("notify", `${notifyUsers}`)
            data.append("position", formData.position)
            if (formData.endTime) {
                data.append("endTime", new Date(formData.endTime).toISOString());
            }

            // Ensure mediaUrl is a File object before appending
            if (formData.mediaUrl instanceof File) {
                data.append("media", formData.mediaUrl);
            } else {
                console.warn("mediaUrl is not a valid file");
            }

            for (let [key, value] of data.entries()) {
                console.log(`${key}:`, value);
            }


            try {
                const token = localStorage.getItem("token");
                const response = await fetch(`${BASE_URL}/community/noticeboard/create`, {
                    method: "PUT",
                    headers: {
                        "auth-token": token,  // ✅ Do NOT set Content-Type manually
                    },
                    body: data
                });

                const json = await response.json();
                console.log(json);

                if (json.success === true) {
                    onSuccess()
                    alert("Noticeboard updated successfully!");
                } else {
                    alert(`${json.response}`);
                }

            } catch (error) {
                console.error("Submission error:", error);
                alert("Error sharing data in noticeboard!");
            }
        } else {
            alert("Please enter a valid number in position")
        }
    };


    return (
        <Dialog open={open} onClose={onClose} >
            <DialogTitle style={{ background: "#202020", fontFamily: "poppins-mid" }}>Add To Noticeboard</DialogTitle>
            <DialogContent style={{ background: "#202020" }}>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <TextField fullWidth margin="dense" label="Noticeboard title..." name="title" value={formData.title} onChange={handleChange} required
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff20", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }}
                    />
                    <TextField fullWidth margin="dense" label="Description" name="description" value={formData.description} onChange={handleChange} multiline rows={3}
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }} />

                    <TextField fullWidth margin="dense" label="Position" required name="position" placeholder="Enter position number of the slide"
                        value={formData.position} onChange={handleChange} multiline inputMode={'decimal'}
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }} />

                    <TextField fullWidth margin="dense" label="Space" name="Space" value={`${communityName} (${community})`}
                        sx={{
                            fontSize: "14px",
                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",  // Change label font family
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                            },
                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg", // Change font family
                                fontSize: "14px", // Change font size
                            },
                        }}

                        disabled />

                    {/* Creator Dropdown */}
                    <FormControl fullWidth margin="dense" required>
                        <InputLabel style={{ fontFamily: "poppins-reg", color: "#ffffff90", background: "202020" }}>Creator</InputLabel>
                        <Select style={{
                            fontFamily: 'poppins-reg', fontSize: "14px"
                        }} name="creator" value={formData.creator} onChange={handleChange} required>
                            {COMMUNITYADMINS.map((creator) => (
                                <MenuItem key={creator.id} value={creator.id}>{creator.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>



                    {/* Redirect Type (Inside/Outside) */}
                    <FormControl component="fieldset" margin="dense">
                        <RadioGroup row name="redirectType" value={formData.redirectType} onChange={handleChange}>
                            <FormControlLabel
                                value="inside"
                                control={<Radio sx={{
                                    color: "#ffffff90", // Default color
                                    "&.Mui-checked": {
                                        color: "white", // Selected color
                                    },
                                }} />}
                                label="Open Inside"
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: "14px", // Change font size
                                        fontFamily: "poppins-reg", // Change font family
                                        color: "#ffffff", // Change font color
                                    },
                                }}
                            />
                            <FormControlLabel
                                value="outside"
                                control={<Radio sx={{
                                    color: "#ffffff90", // Default color
                                    "&.Mui-checked": {
                                        color: "white", // Selected color
                                    },
                                }} />}
                                label="Open Outside"
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: "14px",
                                        fontFamily: "poppins-reg",
                                        color: "#ffffff",
                                    },
                                }}
                            />

                            <FormControlLabel
                                value="none"
                                control={<Radio sx={{
                                    color: "#ffffff90", // Default color
                                    "&.Mui-checked": {
                                        color: "white", // Selected color
                                    },
                                }} />}
                                label="Do nothing"
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: "14px",
                                        fontFamily: "poppins-reg",
                                        color: "#ffffff",
                                    },
                                }}
                            />
                        </RadioGroup>
                    </FormControl>

                    {
                        formData.redirectType == "outside" && (
                            <TextField fullWidth margin="dense" label="Redirect URL" name="redirectUrl" value={formData.redirectUrl} onChange={handleChange} type="url"
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiInputLabel-root": {
                                        color: "#ffffff90",
                                        fontFamily: "poppins-reg",  // Change label font family
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontFamily: "poppins-reg", // Change font family
                                        fontSize: "14px", // Change font size
                                    },
                                }} />
                        )
                    }

                    {
                        formData.redirectType == "inside" && (
                            <TextField fullWidth margin="dense" label="Redirect Id or event Id" name="redirectId" value={formData.redirectId} onChange={handleChange}
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiInputLabel-root": {
                                        color: "#ffffff90",
                                        fontFamily: "poppins-reg",  // Change label font family
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontFamily: "poppins-reg", // Change font family
                                        fontSize: "14px", // Change font size
                                    },
                                }} />
                        )
                    }

                    {
                        formData.redirectType == "inside" && (
                            <TextField fullWidth margin="dense" label="ID Type (Event or Empty)" name="idType" value={formData.idType} onChange={handleChange}
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiInputLabel-root": {
                                        color: "#ffffff90",
                                        fontFamily: "poppins-reg",  // Change label font family
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&:hover fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                        "&.Mui-focused fieldset": { borderColor: "#ffffff40", borderRadius: "10px" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontFamily: "poppins-reg", // Change font family
                                        fontSize: "14px", // Change font size
                                    },
                                }} />
                        )
                    }

                    <TextField
                        fullWidth
                        margin="dense"
                        label="End Time"
                        name="endTime"
                        type="datetime-local"
                        value={formData.endTime}
                        onChange={handleChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        helperText="This slide will disappear after the selected time. Leave empty to not auto remove."
                        sx={{
                            fontSize: "14px",

                            "& .MuiInputLabel-root": {
                                color: "#ffffff90",
                                fontFamily: "poppins-reg",
                            },

                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    borderColor: "#ffffff40",
                                    borderRadius: "10px",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#ffffff40",
                                    borderRadius: "10px",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#ffffff40",
                                    borderRadius: "10px",
                                },
                            },

                            "& .MuiInputBase-input": {
                                fontFamily: "poppins-reg",
                                fontSize: "14px",
                                color: "#ffffff",
                            },

                            "& .MuiFormHelperText-root": {
                                color: "#ffffff70",
                                fontFamily: "poppins-reg",
                                fontSize: "11px",
                                marginLeft: "0px",
                            },

                            "& input::-webkit-calendar-picker-indicator": {
                                filter: "invert(1)",
                                cursor: "pointer",
                            },
                        }}
                    />


                    {/* File Upload */}
                    <input type="file" accept="image/*" onChange={handleFileChange} required style={{ marginTop: "10px", fontFamily: "poppins-reg", width: "100%" }} />



                    <FormControlLabel
                        control={
                            <Checkbox checked={notifyUsers} sx={{
                                color: '#aaa',
                                '&.Mui-checked': {
                                    color: '#4caf50', // your custom color when checked
                                },
                            }} onChange={() => {
                                setNotifyUsers(!notifyUsers)
                            }} />
                        }

                        sx={{
                            marginTop: "20px",
                            fontFamily: "poppins-reg"
                        }}
                        label="Notify space members?"
                    />


                    <DialogActions>
                        <Button onClick={onClose} style={{ fontFamily: "poppins-reg", color: "#ffffff" }}>Cancel</Button>
                        <Button type="submit" style={{ fontFamily: "poppins-reg", color: "#ffffff", background: "#706dea" }} variant="contained">Upload</Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default SpaceNoticeboardAdd;
